
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/omoda",
      function () {
        return require("private-next-pages/omoda.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/omoda"])
      });
    }
  